import { getApplicationDurationType } from '@gbr-monorepo/frontend';
import { UserApplication } from '@gbr-monorepo/interfaces';
import { CustomerApplicationType } from '../interfaces/application-type.enum';

export class ApplicationStateOperations {
    public static getApplicationType(application: UserApplication): CustomerApplicationType {
        return getApplicationDurationType(application.travelStartDate, application.travelEndDate) === 'LONG'
            ? CustomerApplicationType.LONG
            : CustomerApplicationType.SHORT;
    }
}
